import { render, staticRenderFns } from "./SectionPosts.vue?vue&type=template&id=51f12ffe"
import script from "./SectionPosts.vue?vue&type=script&lang=js"
export * from "./SectionPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/var/www/html/jayuvillage/components/Loading.vue').default,ScrollLoading: require('/var/www/html/jayuvillage/components/scrollLoading.vue').default,Navigation: require('/var/www/html/jayuvillage/components/navigation.vue').default})
